import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import './Alert.css'
import * as actions from '../store/actions'
import { AppContext } from '../../index'

function Alert() {
  const { state, execute } = useContext(AppContext)
  const alert = state.diags.alert
  const { t } = useTranslation(['global'])

  function hideAlert() {
    execute(actions.hideAlert())
  }

  if (alert.open) {
    return (
      <div id="alert-container">
        <div id="alert">
          <div id="alert-title"><b>{alert.title}</b></div>
          <div id="alert-body">
            <div>{alert.text}</div>
          </div>
          <div id="alert-footer">
            <button onClick={() => hideAlert()}>{ t('close') }</button>
          </div>
        </div>
      </div>
    )
  } else {
    return null
  }
}

export default Alert
